import core from "@gtmhub/core/module";
import { TeamReflectionsComponent } from "@webapp/reflections/components/team-reflections/team-reflections.component";
import reflectionsCore from "./reflections-core.module";

const mod = angular.module("reflections", [core, reflectionsCore]);

mod.downgradeComponent("teamReflections", { component: TeamReflectionsComponent, propagateDigest: false });

export default mod.name;
